let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i5sxz")).then(() => parcelRequire('38vJk'));